import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    authToken: '',
    user: {},
    facilities_inspection: {
        ANL_ID: 0,
        ANL_BEZEICHNUNG: '',
        DB776_CODE: '',

        date: new Date(),
        userName: '',
        userFirstname: '',
        userLastname: '',
        pdfFilename: '',
        pdfSent: false,
        pdfSendTimestamp: new Date(),

        inspectForm: '',
        
        stateClass_values: ['1', '2', '3', '4', '5'],
        stateClass: '',
        stateAdditive_values: ['Kein Zusatz', 'S'],
        stateAdditive: '',
        stateComment: '',

        actionDriveSlowly: false,
        trainrouteBlock: false,
        actionComment: '',

        comment: '',
        images: [],
 
        check: []
    },
    check_mauer: [
        {
            id: 1,
            name: 'Bewuchs: Moos / Gräser',
            values: ['1', '2', '3', '4', '5'],
            selected_value: '',
            
            is_action_added: false,
            action: {
                field_name: 'Bewuchs: Moos / Gräser',
                actions_title: 'Bewuchs entfernen',
                actions: ['ASC', 'AT'],
                selected_action: '',
                deadline_title: 'Fristen',
                deadline: ''
            }
        },
        {
            id: 2,
            name: 'Bewuchs: Sträucher',
            values: ['1', '2', '3', '4', '5'],
            selected_value: '',
            
            is_action_added: false,
            action: {
                field_name: 'Bewuchs: Sträucher',
                actions_title: 'Mauerkrone freilegen',
                actions: ['ASC', 'AT'],
                selected_action: '',
                deadline_title: 'Fristen',
                deadline: ''
            }
        },
        {
            id: 3,
            name: 'Entwässerungsgraben',
            values: ['1', '2', '3', '4', '5'],
            selected_value: '',
            
            is_action_added: false,
            action: {
                field_name: 'Entwässerungsgraben',
                actions_title: 'Graben räumen',
                actions: ['ASC', 'AT'],
                selected_action: '',
                deadline_title: 'Fristen',
                deadline: ''
            }
        },
        {
            id: 4,
            name: 'Rückentwässerung',
            values: ['1', '2', '3', '4', '5'],
            selected_value: '',
            
            is_action_added: false,
            action: {
                field_name: 'Rückentwässerung',
                actions_title: 'Entwässerungsöffnungen reinigen ',
                actions: ['ASC', 'AT'],
                selected_action: '',
                deadline_title: 'Fristen',
                deadline: ''
            }
        },
        {
            id: 5,
            name: 'Entwässerungsfunktion gegeben ',
            values: ['Ja', 'Nein'],
            selected_value: '',
            
            is_action_added: false,
            action: {
                field_name: 'Entwässerungsfunktion gegeben ',
                actions_title: 'Verfugung instand setzen',
                actions: ['Ja', 'Nein'],
                selected_action: '',
                deadline_title: 'Fristen',
                deadline: ''
            }
        },
        {
            id: 6,
            name: 'Ausbrüche / Abplatzungen',
            values: ['1', '2', '3', '4', '5'],
            selected_value: '',
            
            is_action_added: false,
            action: {
                field_name: 'Ausbrüche / Abplatzungen',
                actions_title: 'Oberfläche - Risse injizieren',
                actions: ['ASC', 'AT'],
                selected_action: '',
                deadline_title: 'Fristen',
                deadline: ''
            }
        },
        {
            id: 7,
            name: 'Verfugungsschäden',
            values: ['1', '2', '3', '4', '5'],
            selected_value: '',
            
            is_action_added: false,
            action: {
                field_name: 'Verfugungsschäden',
                actions_title: 'Abplatzungen inst. setz. / Einzelsteine',
                actions: ['ASC', 'AT'],
                selected_action: '',
                deadline_title: 'Fristen',
                deadline: ''
            }
        },
        {
            id: 8,
            name: 'Risse im Beton / Mauerwerk',
            values: ['1', '2', '3', '4', '5'],
            selected_value: '',
            
            is_action_added: false,
            action: {
                field_name: 'Risse im Beton / Mauerwerk',
                actions_title: 'Abdeckbalken - neu',
                actions: ['ASC', 'AT'],
                selected_action: '',
                deadline_title: 'Fristen',
                deadline: ''
            }
        },
        {
            id: 9,
            name: 'Ausbauchungen / Verformung',
            values: ['1', '2', '3', '4', '5'],
            selected_value: '',
            
            is_action_added: false,
            action: {
                field_name: 'Ausbauchungen / Verformung',
                actions_title: 'Instand setzen',
                actions: ['ASC', 'AT'],
                selected_action: '',
                deadline_title: 'Fristen',
                deadline: ''
            }
        },
        {
            id: 10,
            name: 'Absturzsicherung',
            values: ['1', '2', '3'],
            selected_value: '',
            
            is_action_added: false,
            action: {
                field_name: 'Absturzsicherung',
                actions_title: 'Absturzsicherung - neu anbringen',
                actions: ['ASC', 'AT'],
                selected_action: '',
                deadline_title: 'Fristen',
                deadline: ''
            }
        },
        {
            id: 11,
            name: 'Grabenabdeckung',
            values: ['1', '2', '3'],
            selected_value: '',
            
            is_action_added: false,
            action: {
                field_name: 'Grabenabdeckung',
                actions_title: 'Streichen / befestigen / reparieren',
                actions: ['ASC', 'AT'],
                selected_action: '',
                deadline_title: 'Fristen',
                deadline: ''
            }
        },
        {
            id: 12,
            name: 'Abdeckbalken',
            values: ['1', '2', '3'],
            selected_value: '',
            
            is_action_added: false,
            action: {
                field_name: 'Abdeckbalken',
                actions_title: 'Erneuerung / Erweiterung',
                actions: ['ASC', 'AT'],
                selected_action: '',
                deadline_title: 'Fristen',
                deadline: ''
            }
        },
        {
            id: 13,
            name: 'Aufgesetzter Steinschlagschutz',
            values: ['1', '2', '3'],
            selected_value: '',
            
            is_action_added: false,
            action: {
                field_name: 'Aufgesetzter Steinschlagschutz',
                actions_title: 'Maßnahme',
                actions: ['ASC', 'AT'],
                selected_action: '',
                deadline_title: 'Fristen',
                deadline: ''
            }
        }
    ],
    check_durchlass: [
        {
            id: 1,
            name: 'Bewuchs: Moos/Sträucher/etc.',
            values: ['1', '2', '3', '4', '5'],
            selected_value: '',
            
            is_action_added: false,
            action: {
                field_name: 'Bewuchs: Moos/Sträucher/etc.',
                actions_title: 'Bewuchs entfernen',
                actions: ['ASC', 'AT'],
                selected_action: '',
                deadline_title: 'Fristen',
                deadline: ''
            }
        },
        {
            id: 2,
            name: 'Verschlammung/Anladungen',
            values: ['1', '2', '3', '4', '5'],
            selected_value: '',
            
            is_action_added: false,
            action: {
                field_name: 'Verschlammung/Anladungen',
                actions_title: 'Durchlass räumen',
                actions: ['ASC', 'AT'],
                selected_action: '',
                deadline_title: 'Fristen',
                deadline: ''
            }
        },
        {
            id: 3,
            name: 'Ausbrüche / Abplatzungen',
            values: ['1', '2', '3', '4', '5'],
            selected_value: '',
            
            is_action_added: false,
            action: {
                field_name: 'Ausbrüche / Abplatzungen',
                actions_title: 'Ein- u. Auslaufbereich räumen',
                actions: ['ASC', 'AT'],
                selected_action: '',
                deadline_title: 'Fristen',
                deadline: ''
            }
        },
        {
            id: 4,
            name: 'Schäden an Fugen',
            values: ['1', '2', '3', '4', '5'],
            selected_value: '',
            
            is_action_added: false,
            action: {
                field_name: 'Schäden an Fugen',
                actions_title: 'Ein- und Auslauf befestigen',
                actions: ['ASC', 'AT'],
                selected_action: '',
                deadline_title: 'Fristen',
                deadline: ''
            }
        },
        {
            id: 5,
            name: 'Risse im Beton / Mauerwerk',
            values: ['1', '2', '3', '4', '5'],
            selected_value: '',
            
            is_action_added: false,
            action: {
                field_name: 'Risse im Beton / Mauerwerk',
                actions_title: 'Fugen instand setzen',
                actions: ['ASC', 'AT'],
                selected_action: '',
                deadline_title: 'Fristen',
                deadline: ''
            }
        },
        {
            id: 6,
            name: 'Ausbauchungen / Verformung',
            values: ['1', '2', '3', '4', '5'],
            selected_value: '',
            
            is_action_added: false,
            action: {
                field_name: 'Ausbauchungen / Verformung',
                actions_title: 'Oberfläche - Risse injizieren',
                actions: ['ASC', 'AT'],
                selected_action: '',
                deadline_title: 'Fristen',
                deadline: ''
            }
        },
        {
            id: 7,
            name: 'Geländer rdB',
            values: ['fehlt', '1', '3', '5'],
            selected_value: '',
            
            is_action_added: false,
            action: {
                field_name: 'Geländer rdB',
                actions_title: 'Abplatzungen inst. setz. / Einzelsteine',
                actions: ['ASC', 'AT'],
                selected_action: '',
                deadline_title: 'Fristen',
                deadline: ''
            }
        },
        {
            id: 8,
            name: 'Geländer ldB',
            values: ['fehlt', '1', '3', '5'],
            selected_value: '',
            
            is_action_added: false,
            action: {
                field_name: 'Geländer ldB',
                actions_title: 'Randbalken - neu',
                actions: ['ASC', 'AT'],
                selected_action: '',
                deadline_title: 'Fristen',
                deadline: ''
            }
        },
        {
            id: 9,
            name: 'Randbalken rdB',
            values: ['fehlt', '1', '3', '5'],
            selected_value: '',
            
            is_action_added: false,
            action: {
                field_name: 'Randbalken rdB',
                actions_title: 'Instand setzen',
                actions: ['ASC', 'AT'],
                selected_action: '',
                deadline_title: 'Fristen',
                deadline: ''
            }
        },
        {
            id: 10,
            name: 'Randbalken ldB',
            values: ['fehlt', '1', '3', '5'],
            selected_value: '',
            
            is_action_added: false,
            action: {
                field_name: 'Absturzsicherung',
                actions_title: 'Absturzsicherung - neu anbringen',
                actions: ['ASC', 'AT'],
                selected_action: '',
                deadline_title: 'Fristen',
                deadline: ''
            }
        },
        {
            id: 11,
            name: 'Befestigung Ein-/Auslaufber. ldB',
            values: ['1', '2', '3'],
            selected_value: '',
            
            is_action_added: false,
            action: {
                field_name: 'Befestigung Ein-/Auslaufber. ldB',
                actions_title: 'Streichen / befestigen / reparieren',
                actions: ['ASC', 'AT'],
                selected_action: '',
                deadline_title: 'Fristen',
                deadline: ''
            }
        },
        {
            id: 12,
            name: 'Befestigung Ein-/Auslaufber. rdB',
            values: ['1', '2', '3'],
            selected_value: '',
            
            is_action_added: false,
            action: {
                field_name: 'Befestigung Ein-/Auslaufber. rdB',
                actions_title: 'Erneuerung Durchlass',
                actions: ['ASC', 'AT'],
                selected_action: '',
                deadline_title: 'Fristen',
                deadline: ''
            }
        },
        {
            id: 13,
            name: 'Abschluss ldB',
            values: ['fehlt', '1', '3', '5'],
            selected_value: '',
            
            is_action_added: false,
            action: {
                field_name: 'Abschluss ldB',
                actions_title: 'Durchlass verlängern / Abschluss',
                actions: ['ASC', 'AT'],
                selected_action: '',
                deadline_title: 'Fristen',
                deadline: ''
            }
        },
        {
            id: 14,
            name: 'Abschluss rdB',
            values: ['fehlt', '1', '3', '5'],
            selected_value: '',
            
            is_action_added: false,
            action: {
                field_name: 'Abschluss rdB',
                actions_title: 'Maßnahme',
                actions: ['ASC', 'AT'],
                selected_action: '',
                deadline_title: 'Fristen',
                deadline: ''
            }
        }
    ],
    was_Upload_successful: false
  },
  mutations: {
    updateCredentials (state, _credentials) {
      state.authToken = _credentials.token;
      state.user = _credentials.user;
    }
  },
  actions: {
  }
})
